export function dropdownBoxMenu() {

  controller.$inject = ['$scope'];
  function controller($scope) {


    init();
  
    function init() {
      $scope.hasEnabledBtns = $scope.menuItems.find(el => el.enabled);
    }
    
  } 

  return {
    restrict: 'E',
    template: require('./dropdownBoxMenu.directive.html'),
    scope: {
      menuIcon: "<",
      menuItems: "="
    },
    controller: controller
  };

}
